import React, { useState } from "react";
import utils from "./utils";
import Image from "./Image";
import styles from "./styles";
import Dialpad from "components/Dialpad/Dialpad";
import { useRef } from "react";
import { useEffect } from "react";


const GlassRenderer = props => {
  const {
    itemRef,
    itemPosition,
    activePosition,
    elementDimensions,
    itemDimensions,
    active,
    imageSrc,
    largeImageSrc,
    imageAlt,
    magnifierBorderSize,
    square,
    magnifierSize,
    magnifierOffsetX,
    magnifierOffsetY,
    renderOverlay,
    cursorStyle,
    onImageLoad,
    onLargeImageLoad,
    onLoadRefresh,
    callback,
    submit
  } = props;

  const [lastDivPosition,setLastDivPosition] = useState({x:0,y:0})
  const [lastPosition,setLastPosition] = useState({x:0,y:0})
  // this.lastDivPosition = {x:0,y:0}
  // this.lastPosition={x:0,y:0}

  // const [magnifierBorderColor,setMagnifierBorderColor] = useState(props.magnifierBorderColor)
  let magnifierBorderColor = props.magnifierBackgroundColor
  let magnifierBackgroundColor = props.magnifierBackgroundColor

  const letters=['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','/','*','#','@','-','.',' ','DEL']

  const [selectedLetter, setSelectedLetter] = useState("")
  const [isFinished, setIsFinished] = useState(false)
  const [isMoved, setIsMoved] = useState(false)
  

  // useEffect(() => {
  //   if (isFinished) {
  //     submit(selectedLetter)
  //   }
  // }, [isFinished])

  useEffect(()=>{
    console.log("targeted useEffect called... values are:",isFinished,selectedLetter)
    if(isFinished){
      setIsMoved(false)
      setIsFinished(false)
      callback(selectedLetter)
    }
  },[selectedLetter,isFinished])
  useEffect(()=>{
    if(!isMoved){
      magnifierBorderColor= props.magnifierBackgroundColor
      magnifierBackgroundColor="rgba(255,255,255,0.5)"
      setSelectedLetter("")
    }
  },[isMoved])

  const legalSize = itemDimensions.width > elementDimensions.width;
  const isActive = legalSize && active;

  const magnifierSizeNum = utils.convertWidthToPx(
    magnifierSize,
    elementDimensions.width
  );

  const imageRef = useRef(null)
  const magRef = useRef(null)

  // var selectedLetter



  const positionOffset = magnifierSizeNum / 2;

  

  
  // const borderRadius = "0";
  const borderRadius = square ? "0" : "50%";
  // console.log("activePosition:",activePosition)
  let ratio = itemDimensions.width /elementDimensions.width
  
  let middleWidth = elementDimensions.width /2.0
  let middleHeight = elementDimensions.height /2.0
  // console.log("middle width",middleWidth,"middle heigth",middleHeight)
  let distance = Math.sqrt(Math.pow(middleWidth-activePosition.x,2) + Math.pow(middleHeight-activePosition.y,2))
  
  
  let angle = Math.atan2(activePosition.y-middleHeight,activePosition.x-middleWidth)
  let angleStep = 2*Math.PI/34
  let angleOffset = Math.round(angle/angleStep)

  let widthDistanceFromCenter,heigthDistanceFromCenter;
  // console.log("angleOffset:",angleOffset)
  let letterIndex = angleOffset<0?(-angleOffset+1)%34:(34-angleOffset+1)
  letterIndex=letterIndex%34
  if(Math.abs(angleOffset)%2==1){
    if(distance<middleWidth*0.8){
      // letterIndex++
      widthDistanceFromCenter = middleWidth * 0.65
      heigthDistanceFromCenter = middleHeight * 0.65
    }else{
      // letterIndex++
      angleOffset = Math.round(angleOffset/2) * 2 
      widthDistanceFromCenter = middleWidth * 0.85
      heigthDistanceFromCenter = middleHeight * 0.85
    }
  }else{
    if(distance<middleWidth*0.8){

    }else{
      // letterIndex++
      widthDistanceFromCenter = middleWidth * 0.85
      heigthDistanceFromCenter = middleHeight * 0.85

    }
    
    
  }
  
  // console.log("distance:",distance)
  
  
  // console.log(letterIndex)
  // console.log("selected letter:", letters[(letterIndex-1+34)%34])
  
  let roundedAngel = angleOffset * angleStep
  let newX = middleWidth + widthDistanceFromCenter * Math.cos(roundedAngel)
  let newY = middleHeight+ heigthDistanceFromCenter * Math.sin(roundedAngel)


  let localDistance = Math.sqrt(Math.pow(newX-activePosition.x,2) + Math.pow(newY-activePosition.y,2))
  // console.log("localDistance:",localDistance)
  // console.log(newX-activePosition.x,newY-activePosition.y,localDistance)

  if(localDistance > 0 && localDistance<15 && isMoved){
    magnifierBorderColor="rgba(0,255,0,0.4)"
    magnifierBackgroundColor= "radial-gradient(circle, rgba(255,255,255,0) 30%, rgba(0,255,0,0.4) 100%)"
    // selectedLetter = letters[(letterIndex-1+34)%34]
    if(selectedLetter!=letters[(letterIndex-1+34)%34])
      setSelectedLetter(letters[(letterIndex-1+34)%34])
    
    // callback(selectedLetter)
  }else if(localDistance>=15 && localDistance<50){
    magnifierBorderColor="rgba(255,255,255,0.5)"
    magnifierBackgroundColor= props.magnifierBackgroundColor
    if(selectedLetter!="")
      setSelectedLetter("")
    // setSelectedLetter("")
    // selectedLetter=null
    // callback("")
  }

  // let newLargeX = middleWidth*2 + middleWidth*2 *Math.cos(roundedAngel)
  // let newLargeY = middleHeight*2 +middleHeight*2 * Math.sin(roundedAngel)

  // const divPosition = {
  //   x: activePosition.x - positionOffset + magnifierOffsetX,
  //   y: activePosition.y - positionOffset + magnifierOffsetY
  // };

  // if(distance>75){
    let divPosition = {
      x: newX - positionOffset + magnifierOffsetX,
      y: newY - positionOffset + magnifierOffsetY
    };
    
  let position = {
    // x:  -newLargeX - magnifierBorderSize,
    // x:  -2 * newX  - magnifierBorderSize,
    // y:  -2 * newY  - magnifierBorderSize
    // y:  -newLargeY - magnifierBorderSize
    // x: -ratio * newX - (ratio-1) * positionOffset  ,
    // x: -2 * newX - positionOffset - magnifierBorderSize ,
    x: itemPosition.x - newX + positionOffset - magnifierBorderSize,
    y: itemPosition.y - newY + positionOffset - magnifierBorderSize
    // y: -2 * newY - positionOffset - magnifierBorderSize 
    // y: -ratio * newY - (ratio-1) * positionOffset 
  };
  


  // if(distance>0 && distance<100){
  //   divPosition={...this.lastDivPosition}
  //   position={...this.lastPosition}
  // }
  // else{
  //   this.lastDivPosition(divPosition)
  //   this.lastPosition(position)
  // }
  


  
  // }

  // console.log("itemPosition:",itemPosition)
  // console.log("newCoordinates:",newX,newY)
  // console.log("position:",position.x,position.y)
  // console.log("divPosition:",divPosition.x,divPosition.y)
  // console.log("itemDimentions:",itemDimensions)
  

  // console.log("distance: ",distance, "angle: ",angle,"roundedAngel: ",roundedAngel)

  useEffect(()=>{
    imageRef.current.addEventListener('touchstart',(e)=>{
      setIsMoved(true)
    })

    imageRef.current.addEventListener('touchend',(e)=>{
      setIsFinished(true)
    })

    imageRef.current.addEventListener('mousedown',(e)=>{
      setIsMoved(true)
    })
    imageRef.current.addEventListener('mouseup',(e)=>{
      setIsFinished(true)
    })
    
    imageRef.current.addEventListener('mousemove',(e)=>{
      setIsMoved(true)
    })
  },[])
  

  return (
      <>
      <Image
      // onClick={(e)=>{console.log("onclick!")}}
      // onTouchStart={(e)=>{console.log("onTouch",e)}}
      ref={imageRef}
        style={{
          width: "100%",
          display: "block",
          boxSizing: "border-box",
          cursor: legalSize ? cursorStyle : "default"
        }}
        src={imageSrc}
        alt={imageAlt}
        onImageLoad={onImageLoad}
        onLoadRefresh={onLoadRefresh}
      />
      
      <div
        // onClick={(e)=>{console.log("onclick!")}}
        // onTouchEnd={(e)=>{console.log("onTouchEnd",e)}}
        style={{
          ...styles.getZoomContainerStyle(
            magnifierSizeNum,
            magnifierSizeNum,
            true
          ),
          // visibility: !isActive ? "hidden" : "visible",
          visibility: "visible",
          borderRadius,
          zIndex: "1",
          border: `${magnifierBorderSize}px solid ${magnifierBorderColor}`,
          // border: `${magnifierBorderSize}px solid black`,
          transform: `translate(${divPosition.x}px, ${divPosition.y}px)`,
          background: magnifierBackgroundColor,
          // background: "radial-gradient(circle, rgba(255,255,255,0) 0%, rgba(0,255,0,0.7) 100%)",
          backgroundClip: "padding-box"
        }}
      >
        <Image
          // style={styles.getLargeImageStyle(position.x, position.y, isActive)}
          style={styles.getLargeImageStyle(position.x, position.y, true)}
          ref={itemRef}
          src={largeImageSrc || imageSrc}
          alt={imageAlt}
          onImageLoad={onLargeImageLoad}
          onLoadRefresh={onLoadRefresh}
          // ref={magRef}
        />
        <div
        style={{
          // position:"relative",
          zIndex:100,
          height:"100%",
          width:"100%",
          background:magnifierBackgroundColor,
          top:0,
          left:0,
          borderRadius:"50%"
        }}
      >
        
      </div>
      </div>
      
      {renderOverlay ? renderOverlay(active) : null}
      </>
      
  );
};

export default GlassRenderer;